import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import cx from 'classnames'
import constants from 'common/helpers/constants'
import { FormattedMessage } from 'sb-react-intl'

import Button from 'components/buttons/Button/Button'
import BackNextModal from 'components/modal/BackNextModal/BackNextModal'

import messages from './messages'
import s from './ChooseGiftCardDeliveryTypeModal.scss'


class ChooseGiftCardDeliveryTypeModal extends Component {

  static propTypes = {
    data: PropTypes.shape({
      onBack: PropTypes.func.isRequired,
      onChoose: PropTypes.func.isRequired,
    }),
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.gifts.ChooseGiftCardDeliveryType,
  }

  handleClose = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  goBack = () => {
    const { data: { onBack } } = this.props

    this.handleClose()

    if (typeof onBack === 'function') {
      onBack()
    }
  }

  handleChooseMailType = () => {
    const { data: { onChoose } } = this.props

    this.handleClose()
    onChoose(constants.deliveryTypes.mail)
  }

  handleChooseEmailType = () => {
    const { data: { onChoose } } = this.props

    this.handleClose()
    onChoose(constants.deliveryTypes.email)
  }

  render() {
    const { name } = this.props

    return (
      <BackNextModal
        className={s.chooseGiftCardDeliveryTypeModal}
        dataTestId={constants.testIds.modal.chooseGiftCardDeliveryTypeModal}
        name={name}
        onClose={this.handleClose}
        onBack={this.goBack}
      >
        <FormattedMessage className={s.title} tag="div" {...messages.title} />
        <FormattedMessage className={s.hint} tag="div" {...messages.hint} />
        <div className={s.content}>
          <div className={s.box}>
            <div className={cx(s.image, s.emailIcon)} />
            <FormattedMessage className={s.boxTitle} tag="div" {...messages.byEmail} />
            <Button
              className={s.button}
              id="giftByEmailButton"
              title={messages.buttonTitle}
              sm
              brand
              halfPadding
              fullWidthOnMobile
              onClick={this.handleChooseEmailType}
            />
          </div>
          <div className={s.box}>
            <div className={cx(s.image, s.mailIcon)} />
            <FormattedMessage className={s.boxTitle} tag="div" {...messages.byMail} />
            <Button
              className={s.button}
              id="giftByMailButton"
              title={messages.buttonTitle}
              sm
              brand
              halfPadding
              fullWidthOnMobile
              onClick={this.handleChooseMailType}
            />
          </div>
        </div>
      </BackNextModal>
    )
  }
}


export default ChooseGiftCardDeliveryTypeModal
